import {
  START_LOADING,
  END_LOADING,
  FETCH_LETTERS,
  FETCH_LETTER,
  ADD_LETTER,
  UPDATE_LETTER,
  DELETE_LETTER,
  CLEAR_CURRENT_LETTER,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  letters: [],
  letter: null,
};

const letters = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_LETTERS:
      return {
        ...state,
        letters: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_LETTER:
      return { ...state, letter: action.payload };
    case ADD_LETTER:
      return {
        ...state,
        letters: [...state.letters, action.payload],
        letter: action.payload, // Assuming you want to view the newly added letter
      };
    case UPDATE_LETTER:
      return {
        ...state,
        letters: state.letters.map((letter) =>
          letter._id === action.payload._id ? action.payload : letter
        ),
        letter:
          state.letter && state.letter._id === action.payload._id
            ? action.payload
            : state.letter,
      };
    case DELETE_LETTER:
      return {
        ...state,
        letters: state.letters.filter(
          (letter) => letter._id !== action.payload
        ),
        letter:
          state.letter && state.letter._id === action.payload
            ? null
            : state.letter,
      };
    case CLEAR_CURRENT_LETTER:
      return { ...state, letter: null };
    default:
      return state;
  }
};

export default letters;
